/* eslint-disable @typescript-eslint/no-explicit-any */
import { DefaultAttribute as TextInputElement } from './TextInputElement';

import { createHexId } from '../../../support/createHexId';

import {
  FormElementType,
  FormElementDefinition,
} from '../../../types/shared/EvaluationForm';

// TODO: Should be { [key: FormElementType]: any }
let DefaultAttributes: {
  [key: string]: any;
} = {
  TextInputElement,
};

export default function createFormElement(
  type: FormElementType,
): FormElementDefinition {
  return {
    id: createHexId(),
    ...DefaultAttributes[type],
  };
}
